import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { scrollToTop } from '../header';
import BrandLogo from '../BrandLogo';
import './style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faLine,
} from '@fortawesome/free-brands-svg-icons';
import Elevenicon from '../../images/payment_channels/7-Eleven.webp';
import BigCIcon from '../../images/payment_channels/bigc.webp';
import CounterIcon from '../../images/payment_channels/counter-service.webp';
import JCBIcon from '../../images/payment_channels/jcb-icon.webp';
import MastercardIcon from '../../images/payment_channels/mastercard-icon.webp';
import VisaIcon from '../../images/payment_channels/visa-icon.webp';
import KPlusIcon from '../../images/payment_channels/k-plus-logo.webp';
import PromptPayIcon from '../../images/payment_channels/promptpay.webp';
const { getCurrentBrand } = require('../../config/brands');

const Footer = () => {
  const { t } = useTranslation();
  const brand = getCurrentBrand();
  
  return (
    <footer className="wpo-site-footer optimize-visibility">
      <div className="wpo-upper-footer">
        <div className="wpo-footer-top">
          <div className="container">
            <div className="row">
              {/* Logo */}
              <div className="col-lg-6 col-md-6 col-sm-6 col-12 custom-grid">
                <div className="logo widget-title">
                  <BrandLogo alt={`${brand.name} logo`} />
                </div>
              </div>
              {/* Social Media Icons */}
              <div className="col-lg-6 col-md-6 col-sm-6 col-12 custom-grid">
                <ul className="social-media-list">
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=61573656926936"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="EZseat Facebook Page"
                    >
                      <FontAwesomeIcon icon={faFacebookF} />
                    </a>
                  </li>
                  {/*<li>
                    <a
                      href="https://www.tiktok.com/@ezseat.asia?_t=8rMB7Zwk0GH&_r=1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faTiktok} />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/ezseat.asia/profilecard/?igsh=MTVkdHQzMXdrbXF3bw=="
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faInstagram} />
                    </a>
                  </li> */}
                  <li>
                    <a
                      href="https://lin.ee/qDCUHjt"
                      target="_blank"
                      rel="noopener noreferrer" 
                      aria-label="Line Customer Service"
                    >
                      <FontAwesomeIcon icon={faLine} />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* Footer Middle */}
        <div className="footer-middle">
          <div className="container">
            <div className="row">
              {/* Contact Widget */}
              <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                <div className="widget market-widget wpo-service-link-widget">
                  <div className="widget-title">
                    <h3>{t('footer.contact')}</h3>
                  </div>
                  <p>{t('footer.social_media_contact')}</p>
                  <div className="contact-ft">
                    <ul>
                      <li>
                        <i className="fi ti-location-pin"></i>{t('footer.address')}
                      </li>
                      <li>
                        <i className="fi ti-mobile"></i>+66 (2)-269-6999
                      </li>
                      <li>
                        <i className="fi flaticon-email"></i>info@thairoute.com
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* Useful Links Widget */}
              <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                <div className="widget link-widget">
                  <div className="widget-title">
                    <h3>{t('footer.links')}</h3>
                  </div>
                  <ul>
                    <li>
                      <Link onClick={() => scrollToTop()} to="/about">{t('footer.about')}</Link>
                    </li>
                    <li>
                      <Link onClick={() => scrollToTop()} to="/destination">{t('destinations')}</Link>
                    </li>
                    <li>
                      <Link onClick={() => scrollToTop()} to="/contact">{t('footer.contact')}</Link>
                    </li>
                    <li>
                      <Link onClick={() => scrollToTop()} to="/home">{t('footer.faq')}</Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Payment Channels Widget */}
              <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                <div className="widget market-widget wpo-service-link-widget">
                  <div className="widget-title">
                    <h3>{t('footer.payment_channels')}</h3>
                  </div>
                  <ul className="payment-channels-list">
                    {[

                      { src: VisaIcon, alt: 'Visa' },
                      { src: MastercardIcon, alt: 'Mastercard' },
                      { src: JCBIcon, alt: 'JCB' },
                      { src: KPlusIcon, alt: 'K Plus' },
                      { src: PromptPayIcon, alt: 'PromptPay' },
                      { src: CounterIcon, alt: 'Counter Service' },
                      { src: Elevenicon, alt: '7-Eleven' },
                      { src: BigCIcon, alt: 'Big C' },
                    ].map((icon, index) => (
                      <li key={index}>
                        <img src={icon.src} alt={icon.alt} className="payment-icon" loading="lazy" />
                      </li>
                    ))}

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Lower Footer */}
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-6 col-md-6 col-12">
              <div className="term">
                <ul>
                  <li>
                    <Link onClick={() => scrollToTop()} to="/Privacy">{t('footer.privacy_policy')}</Link>
                  </li>
                  <li>
                    <Link onClick={() => scrollToTop()} to="/Terms">{t('footer.terms')}</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-6 col-md-6 col-12">
              <p className="copyright">&copy; 2025 {brand.name} {t('footer.rights')}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
